import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import {
	initializeFirestore,
	connectFirestoreEmulator,
} from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

// --- ENV FLAGS (diisi dari .env.* lewat env-cmd) ---
const USE_EMULATORS =
	String(process.env.REACT_APP_USE_EMULATORS).toLowerCase() === 'true';
const EMU_HOST = process.env.REACT_APP_EMU_HOST || '127.0.0.1';
const AUTH_PORT = Number(process.env.REACT_APP_EMU_AUTH_PORT || 9099);
const FUNC_PORT = Number(process.env.REACT_APP_EMU_FUNC_PORT || 5001);
const FIRESTORE_PORT = Number(process.env.REACT_APP_EMU_FS_PORT || 8080);
const STG_PORT = Number(process.env.REACT_APP_EMU_STG_PORT || 9199);
// region Functions production (baseline deploy saat ini: Jakarta)
const FUNCTIONS_REGION =
	process.env.REACT_APP_FUNCTIONS_REGION || 'asia-southeast2';

export const FIREBASE_CONFIG = {
	apiKey: process.env.REACT_APP_API_KEY,
	authDomain: process.env.REACT_APP_AUTH_DOMAIN,
	projectId: process.env.REACT_APP_PROJECT_ID,
	storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
	messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
	appId: process.env.REACT_APP_APP_ID,
};

export const FirebaseApp = initializeApp(FIREBASE_CONFIG);

// App Check — hanya aktifkan di production (bukan emulator)
// Di emulator, App Check di-skip agar tidak perlu debug token
if (!USE_EMULATORS && process.env.REACT_APP_RECAPTCHA_SITE_KEY) {
	initializeAppCheck(FirebaseApp, {
		provider: new ReCaptchaV3Provider(process.env.REACT_APP_RECAPTCHA_SITE_KEY),
		isTokenAutoRefreshEnabled: true,
	});
}

export const FirebaseAuth = getAuth(FirebaseApp);

// Development/staging: disable reCAPTCHA verification untuk Phone Auth
// Agar bisa test dengan test phone numbers tanpa reCAPTCHA (known issue firebase-js-sdk#8387)
// JANGAN aktifkan di production — hanya untuk dev/emulator
if (process.env.NODE_ENV === 'development') {
	FirebaseAuth.settings.appVerificationDisabledForTesting = true;
}
export const FirebaseFunction = getFunctions(FirebaseApp, FUNCTIONS_REGION);
export const FirebaseStorage = getStorage(FirebaseApp);
export const Database = initializeFirestore(FirebaseApp, {
	experimentalAutoDetectLongPolling: process.env.NODE_ENV !== 'development',
	experimentalForceLongPolling: process.env.NODE_ENV === 'development',
});

// --- Connect to emulators (DEV) ---
if (USE_EMULATORS) {
	connectAuthEmulator(FirebaseAuth, `http://${EMU_HOST}:${AUTH_PORT}`);
	connectFunctionsEmulator(FirebaseFunction, EMU_HOST, FUNC_PORT);
	connectFirestoreEmulator(Database, EMU_HOST, FIRESTORE_PORT);
	connectStorageEmulator(FirebaseStorage, EMU_HOST, STG_PORT);

	// optional logging
	// eslint-disable-next-line no-console
	console.info('[Firebase] EMULATORS ON', {
		AUTH_PORT,
		FUNC_PORT,
		FIRESTORE_PORT,
		STG_PORT,
	});
} else {
	// eslint-disable-next-line no-console
	console.info('[Firebase] Using PRODUCTION backends');
}
